import React, { useState, useRef } from 'react';
import { Box } from "@mui/material";
import { Outlet, useLocation, useParams } from "react-router-dom";
import GradeReportsGrid from './GradeReportsGrid'
import PartnerReportsGrid from './PartnerReportsGrid';
import GradeReportsHeaderActions from './GradeReportsHeaderActions';
import { useAuth } from '../../components/auth/AuthProvider';

/**
 * @param {ProtectedRouteProps} props
 */
const GradeReports = () => {

    const location = useLocation();
    const {companyID: requestIDFromRoute} = useParams();
    const requestId = location.state?.requestId || requestIDFromRoute;
    const { user, role } = useAuth();
    const [searchText, setSearchText] = useState('');

    const statusType = location.state?.statusType || "Unknown Status";
    console.log("Status Type in GradeReports:", statusType);

    const tableRef = useRef(null);

    const handleOpenColumns = () => {
        tableRef.current?.openColumnsPanel();
    };

    const handleOpenFilters = () => {
        tableRef.current?.openFiltersPanel();
    };

    const handleStatus = (event) => {
        console.log("handleStatus ..::> ", event);
        // setReportGridFilter
        event ? tableRef.current?.setReportGridFilter(event) : tableRef.current?.clearStatusFilter();
    }

    if (user === undefined) {
        return <div>Loading...</div>;
    }

    const renderFinancialGrid = () => {
        switch (role) {
            case 'operations':
                // If reviewMode, show partner data view (read-only) for Ops to review
                if (location.state?.reviewMode) {
                    return <PartnerReportsGrid
                        tableRef={tableRef}
                        searchText={searchText}
                        isCheckboxColumn={false}
                        isStatusColumn={false}
                        statusType={location.state?.statusType}
                        requestId={requestId}
                        reportName={location.state?.reportName}
                    />;
                }
                return <GradeReportsGrid
                    tableRef={tableRef}
                    searchText={searchText}
                    requestId={requestId}
                />;
            case 'partner':
                return <PartnerReportsGrid
                    tableRef={tableRef}
                    searchText={searchText}
                    isCheckboxColumn={false}
                    isStatusColumn={false}
                    statusType={statusType}
                    requestId={requestId}
                    reportName={location.state?.reportName}
                />;
            case 'admin':
                return <PartnerReportsGrid
                    tableRef={tableRef}
                    searchText={searchText}
                    isCheckboxColumn={false}
                    isStatusColumn={false}
                    statusType={statusType}
                    requestId={requestId}
                    reportName={location.state?.reportName}
                />;
            default:
                return <div>Unauthorized Role</div>;
        }
    }

    return (
        <Box>
            <GradeReportsHeaderActions
                searchText={searchText}
                onSearchChange={setSearchText}
                onOpenColumns={handleOpenColumns}
                onOpenFilters={handleOpenFilters}
                onHandleStatus={handleStatus}
                isStatusFilterActive={true}
            />

            {renderFinancialGrid()}
        </Box>
    )
}

export default GradeReports